/**
 * 共享稿库ugc稿的常用订阅
 */
"use strict";
angular.module("customForUgcModule", []).
controller('customForUgcCtrl', ['$scope', 'storageListenerService', 'localStorageService', 'trsPrintService', 'modalDialog', 'resCtrModalService', '$q', 'trsHttpService', "$state", function($scope, storageListenerService, localStorageService, trsPrintService, modalDialog, resCtrModalService, $q, trsHttpService, $state) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.page = {
            CURRPAGE: 1,
            PAGESIZE: 20
        };
        $scope.status = {
            customid: $state.params.customid
        };
        $scope.data = {
            selectedArray: [],
            operFlags: [],
            printResult: []
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        requestCustomList();
        requestData();
    }
    /**
     * [initOperFlag description] 查询稿件的 取 签 建 撤 信息
     * @return {[type]} [description]
     */
    function initOperFlag(docIds) {
        var deffer = $q.defer();
        var params = {
            serviceid: "mlf_ugc",
            methodname: "queryFlag",
            UgcIds: docIds
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
            var temp = data;
            for (var i in temp) {
                if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf("1") > -1) {
                    data[i].METADATAID = data[i].UGCID;
                    $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                }
            }
            deffer.resolve();
        });
        return deffer.promise;
    };
    /**
     * [viewBigDataInfo description] 取签见撤重 点击弹出
     * @param  {[type]} ChnlDocId  [description] 稿件id
     * @param  {[type]} showRepeat [description] 类型
     * @return {[type]}            [description]
     */
    $scope.viewInfo = function(ChnlDocId, showRepeat, showClick, isUGC) {
        var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
        var infoModal = resCtrModalService.infoModal(ChnlDocId, showRepeat, showClick, operFlags, isUGC);
    };
    /**
     * [showOperFlag description] 显示取签见撤重标志
     * @param  {[type]} guid      [description] 稿件id
     * @param  {[type]} flagIndex [description] 取签见撤重序号
     * @return {[type]}           [description]
     */
    $scope.showOperFlag = function(guid, flagIndex) { //share
        var temp = queryItemBYGUID(guid);
        if (!!temp) {
            return temp.OPERFLAG.substr(flagIndex, 1) == "1" ? true : false;
        } else {
            return false;
        }
    };
    /**
     * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
     * @param  {[type]} guid [description] 稿件id
     * @return {[type]}      [description]
     */
    function queryItemBYGUID(guid) {
        for (var i in $scope.data.operFlags) {
            if (guid == $scope.data.operFlags[i].UGCID) {
                return $scope.data.operFlags[i];
            }
        }
    }
    /**
     * [requestData description] 请求列表
     * @return {[type]} [description]
     */
    function requestData() {
        var deffer = $q.defer();
        var params = {
            serviceid: "mlf_ugc",
            methodname: "queryArticles",
            Method: "queryArticles",
            MetaCategoryId: $scope.status.customid,
            SearchWord: "",
            ContainPage: "1",
            CurrPage: $scope.page.CURRPAGE,
            PageSize: $scope.page.PAGESIZE,
            start: $scope.status.STARTTIME,
            end: $scope.status.ENDTIME
        };
        if (!$scope.keywords) {
            $scope.status.isSearch = false;
        }
        if ($scope.status.isSearch) {
            params.SearchWord = $scope.keywords;
        }
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            $scope.data.items = data.data.ldata;
            $scope.data.items.map(function(value, index) {
                value.METADATAID = value.id + "";
                value.DOCTYPEID = "1";
                return value;
            });
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
            $scope.data.selectedArray = [];
            var ids = $scope.data.items.map(function(value, index) {
                return value.id
            }).join(",");
            initOperFlag(ids);
            storageListenerService.previewPageTurningStorage($scope.data.items, "METADATAID,DOCTYPEID", "fusiongxgPreview");
            localStorageService.set("fusiongxgPreviewNode", $scope.status.customid);
            deffer.resolve();
        });
        return deffer.promise;
    }
    $scope.requestData = requestData;
    /**
     * [fullTextSearch description] 搜索功能
     * @return {[type]} [description]
     */
    $scope.fullTextSearch = function($event) {
        if ($event && $event.keyCode !== 13) return;
        $scope.status.isSearch = true;
        requestData();
    };
    /**
     * [jumpToPage description] 页面跳转
     * @return {[type]} [description]
     */
    $scope.jumpToPage = function() {
        $scope.status.copyCurpage = Number($scope.status.copyCurpage);
        $scope.page.CURRPAGE = $scope.status.copyCurpage = $scope.status.copyCurpage > $scope.page.PAGECOUNT ? $scope.page.PAGECOUNT : $scope.status.copyCurpage;
        requestData();
    };
    /**
     * [singleSelect description] 单个选中
     * @param  {[type]} item [description] 稿件信息
     * @return {[type]}      [description]
     */
    $scope.singleSelect = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        if (index >= 0) {
            $scope.data.selectedArray.splice(index, 1);
        } else {
            $scope.data.selectedArray.push(item);
        }
    };
    /**
     * [selectAll description] 全选
     * @return {[type]} [description]
     */
    $scope.selectAll = function() {
        if ($scope.data.items.length === 0) return;
        var flag = $scope.data.selectedArray.length == $scope.data.items.length;
        $scope.data.selectedArray = flag ? [] : [].concat($scope.data.items);
    };
    /**
     * [openTakeDraftModal description] 取稿
     * @return {[type]} [description]
     */
    $scope.openTakeDraftModal = function() {
        var ids = getIds();
        var params = {
            serviceid: "mlf_ugc",
            methodname: "takeArticle",
            Method: "takeArticle",
            ID: ids,
            SourceName: $scope.status.SourceName
        };
        var modalInstance = resCtrModalService.fullTakeDraft(params, $scope.data.selectedArray.length === 1, $scope.data.selectedArray, true);
        modalInstance.result.then(function() {
            initOperFlag(ids);
            $scope.data.selectedArray = [];
        }, function() {
            initOperFlag(ids);
            $scope.data.selectedArray = [];
        });
    };
    /**
     * [openReserveDraftModal description] 预留
     * @return {[type]} [description]
     */
    $scope.openReserveDraftModal = function() {
        var resCtrModalServiceModal = resCtrModalService.reserveDraft($scope.data.selectedArray, true);
        resCtrModalServiceModal.result.then(function(result) {
            var ids = $scope.data.selectedArray.map(function(value, index) {
                return value.id;
            }).join(",");
            delete result.items;
            result.serviceid = "mlf_ugc";
            result.methodname = "takeArticle";
            result.Method = "takeArticle";
            result.ID = ids;
            result.SourceName = $scope.status.SourceName;
            $scope.status.loadingPromise = $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), result, 'post').then(function(data) {
                modalDialog.alertType("预留成功!", "", "success", false, "");
                requestData();
            }, function() {
                $scope.data.selectedArray = [];
            });
        });
    };
    /**
     * [requestCustomList description:初始化自定义列表]
     */
    function requestCustomList() {
        var deferred = $q.defer();
        var params = {
            serviceid: 'mlf_releasesource',
            methodname: 'queryMyCustoms'
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            var item = data.DATA.filter(function(value, index) {
                return value.CUSTOMID == $scope.status.customid;
            });
            $scope.status.SourceName = item[0].PATH.replace(/\//g, "-");
        });
        return deferred.promise;
    }
    /**
     * [creationAxis description] 添加创作轴
     * @return {[type]} [description]
     */
    $scope.creationAxis = function() {
        var ids = getIds();
        var params = {
            serviceid: "mlf_ugc",
            methodname: "createCreations",
            Method: "articleInfo",
            ID: ids
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            modalDialog.alertType("该稿件已成功加入创作轴!", "", "success", false);
            $scope.data.selectedArray = [];
        });
    };
    /**
     * [collectDraft description] 稿件收藏
     * @return {[type]} [description]
     */
    $scope.collectDraft = function() {
        var params = {
            serviceid: "mlf_ugc",
            methodname: "collectUgcDoc",
            Method: "articleInfo",
            ID: getIds()
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            modalDialog.alertType("稿件收藏成功", "", "success", false);
            $scope.data.selectedArray = [];
        });
    };
    /**
     * [getIds description] 获取选中稿件的id串
     * @return {[type]} [description]
     */
    function getIds() {
        return $scope.data.selectedArray.map(function(value, index) {
            return value.id;
        }).join(",");
    };
    /**
     * [exportDraft description] 导出稿件
     * @return {[type]} [description]
     */
    $scope.exportDraft = function() {
        var params = {
            serviceid: 'mlf_exportword',
            methodname: 'exportUGCDocs',
            Method: "articleInfo",
            ID: getIds()
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            window.open("/wcm/app/file/read_file.jsp?FileName=" + data.replace(/"/g, ""));
            $scope.data.selectedArray = [];
        });
    };
    /**
     * [printbtn description] 打印
     * @return {[type]} [description]
     */
    $scope.printbtn = function() {
        angular.forEach($scope.data.selectedArray, function(value, key) {
            requestPrintData(value);
        });
    };
    /**
     * [requestPrintData description] 打印请求详情
     * @param  {[type]} item    [description] 选中数据
     * @param  {[type]} version [description] 流程版本
     * @return {[type]}         [description]
     */
    function requestPrintData(item, version) {
        var params = {
            serviceid: "mlf_ugc",
            methodname: "queryArticles",
            Method: "articleInfo",
            ID: item.id
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data_) {
            var data = data_.data[0].article;
            var result = {
                HANGCOUNT: Math.ceil(data.articleWordsCount / 27),
                TITLE: data.articleTitle,
                HTMLCONTENT: data.articleHtmlCon,
                DOCWORDSCOUNT: data.articleWordsCount
            };
            $scope.data.printResult.push(result);
            if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                trsPrintService.trsPrintShare($scope.data.printResult);
                $scope.data.printResult = [];
            }
        });
    }
}])